import { render } from "./TransactionComplete.vue?vue&type=template&id=5ff8b872&scoped=true"
import script from "./TransactionComplete.vue?vue&type=script&lang=js"
export * from "./TransactionComplete.vue?vue&type=script&lang=js"

import "./TransactionComplete.vue?vue&type=style&index=0&id=5ff8b872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff8b872"]])

export default __exports__